<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p21"><span><a id="page_17"></a><a href="#/Contents#rp21">ASPARAGUS LEMON SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>This perfect spring luncheon soup is similar to the classic Greek egg lemon soup, with the addition of asparagus and pasta.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1 quart Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>½ cup orzo or other small soup pasta</span></p>
<p class="hang"><span>12 ounces asparagus, sliced</span></p>
<p class="hang"><span>2 eggs, lightly beaten</span></p>
<p class="hang"><span>¼ cup each: lemon juice, sliced green onions</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat stock to boiling in large saucepan. Add orzo; reduce heat and simmer 5 minutes. Stir in asparagus and heat to boiling. Reduce heat and simmer until asparagus and orzo are tender, about 7 minutes. Whisk in eggs gradually; cook 1 minute. Add lemon juice and green onions; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 105</span></p>
<p class="per1"><span>% calories from fat: 22</span></p>
<p class="per1"><span>Protein (g): 12.3</span></p>
<p class="per1"><span>Carbohydrate (g): 6.2</span></p>
<p class="per1"><span>Fat (g): 2.6</span></p>
<p class="per1"><span>Saturated fat (g): 0.6</span></p>
<p class="per1"><span>Cholesterol (mg): 73</span></p>
<p class="per1"><span>Sodium (mg): 32</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 3.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 1.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter023.vue?cbbf6ac4